export default __webpack_public_path__ + "static/media/keyboard_arrow_down.65fd31f3.svg";